export default __webpack_public_path__ + "static/media/search.a679d576.svg";